<!-- @format -->

<ng-container *transloco="let t">
  <div class="sis-plan-structure-module" data-cy="plan-structure-module">
    <sis-expandable
      [title]="(module.name | localizedString) + (targetCredits ? ' (' + (targetCredits | creditRange: 'TEXT') + ')' : '')"
      [contentPadding]="'none'"
      [variant]="'naked-dotted'"
      [closed]="false"
      [level]="headingLevel"
      [size]="getHeadingSize()"
      [elementId]="moduleStateObject?.elementId"
      [disabled]="!isDegreeProgrammeModule()"
      [hideIcon]="!isDegreeProgrammeModule()"
      [titleContainerOutside]="true">
      <ng-template sisExpandableCustomTitle>
        <sis-plan-structure-module-state-badges [documentState]="module.documentState" [stateObject]="moduleStateObject">
        </sis-plan-structure-module-state-badges>
        <div class="expandable__title__sub-title expandable__title__sub-title__size__md">
          <div class="d-flex flex-column flex-sm-row sis-plan-structure-module__font-weight-regular">
            @if (module.code) {
              <fudis-body-text class="fudis-mr-xs fudis-mt-xxs">{{ module.code }}</fudis-body-text>
            }
            @if (module.type === "StudyModule" && module.studyLevel) {
              <fudis-body-text class="fudis-mr-xs fudis-mt-xxs"
                >{{ (module.code ? "| " : "") + (module.studyLevel | codeLocalizedName | async) }}
                @if (moduleStateObject?.studyRightState) {
                  <ng-container
                    [ngTemplateOutlet]="studyRightStateTpl"
                    [ngTemplateOutletContext]="{ state: moduleStateObject?.studyRightState }" />
                }
              </fudis-body-text>
            }
            @if (module.type === "DegreeProgramme" && moduleStateObject?.studyRightState) {
              <fudis-body-text [class]="'fudis-mr-xs fudis-mt-xxs'">
                <ng-container
                  [ngTemplateOutlet]="studyRightStateTpl"
                  [ngTemplateOutletContext]="{ state: moduleStateObject?.studyRightState }" />
              </fudis-body-text>
            }
            @if (module.type !== "GroupingModule") {
              <fudis-body-text class="order-1 fudis-mt-xxs">
                {{ "| " }}
                <a
                  fudisLink
                  data-cy="plan-structure-module-info-link"
                  [title]="t('SIS_COMPONENTS.PLAN.OPEN_MODULE_INFO_MODAL')"
                  [href]="'#'"
                  (click)="openModuleInfoModal($event)"></a>
              </fudis-body-text>
            }
          </div>
        </div>
      </ng-template>
      @if (!(moduleStateObject?.moduleValidationResult?.state === "ATTAINED")) {
        <ng-template sisExpandableHeaderButtons>
          <fudis-icon-button
            data-cy="plan-structure-module-edit-button"
            [ariaLabel]="t('SIS_COMPONENTS.PLAN.ARIA.OPEN_PLAN_EDIT_MODAL')"
            [size]="'small'"
            [icon]="'edit'"
            (handleClick)="openModule()"
            [variant]="'tertiary'" />
        </ng-template>
      }
      <ng-template sisExpandableContent>
        <div class="d-flex" [class.study-background]="useBackgroundColor()" [class.study-background-spacing]="useBackgroundColor()">
          <div class="sis-mr-xs w-max-md-100 order-lg-2 order-3 study-credit-info">
            <div class="d-flex flex-wrap">
              @if (moduleStateObject?.planState !== "ATTAINED" && moduleStateObject?.planState !== "PARTS_ATTAINED") {
                <sis-plan-structure-module-selection-state
                  class="sis-mr-xs"
                  [stateObject]="moduleStateObject"></sis-plan-structure-module-selection-state>
              }
              <sis-description-list-compact [fillByColumn]="false">
                <dl>
                  <ng-template #compactListItem>
                    <dt class="label colon">{{ t("SIS_COMPONENTS.PLAN.LABEL.SELECTED_CREDITS") }}</dt>
                    <dd class="value">{{ (moduleStateObject?.moduleValidationResult?.plannedCredits | creditRange) ?? "-" }} </dd>
                  </ng-template>
                </dl>
              </sis-description-list-compact>
            </div>

            <div class="d-flex flex-column flex-sm-row">
              @if (moduleStateObject?.planState === "ATTAINED" || moduleStateObject?.planState === "PARTS_ATTAINED") {
                <sis-plan-structure-module-selection-state
                  class="sis-mr-xs"
                  [stateObject]="moduleStateObject"></sis-plan-structure-module-selection-state>
              }
              <sis-description-list-compact [fillByColumn]="false">
                <dl>
                  <ng-template #compactListItem>
                    <dt class="label colon">{{ t("SIS_COMPONENTS.PLAN.LABEL.ATTAINED") }}</dt>
                    @if (moduleStateObject?.moduleValidationResult?.attainedCredits; as attainedCredits) {
                      <dd class="value">
                        {{ attainedCredits + " " + t("CREDITS") }}
                      </dd>
                    } @else {
                      <dd class="value">{{ "-" }}</dd>
                    }
                  </ng-template>
                  @if (moduleStateObject?.grade?.abbreviation) {
                    <ng-template #compactListItem>
                      <dt class="label colon">{{ t("SIS_COMPONENTS.PLAN.LABEL.GRADE") }}</dt>
                      <dd class="value">{{ (moduleStateObject?.grade?.abbreviation | localizedString) ?? "-" }}</dd>
                    </ng-template>
                  }
                </dl>
              </sis-description-list-compact>
            </div>
          </div>
        </div>
        <sis-plan-structure-module-content
          [moduleOrEducationStateObject]="planStateObject?.modules[module.id]"
          [moduleOrEducation]="module"
          [isImplicit]="isImplicit"
          [planValidationResult]="planValidationResult"
          [planData]="planData"
          [planStateObject]="planStateObject"
          [headingLevel]="headingLevel + 1">
        </sis-plan-structure-module-content>
      </ng-template>
    </sis-expandable>
  </div>
  <ng-template #studyRightStateTpl let-state="state">
    @switch (state) {
      @case ("CONFIRMED") {
        | <fudis-icon [class]="'fudis-mb-xxs'" [icon]="'check-small'" [color]="'green'" />
      }
      @case ("NOT_CONFIRMED") {
        | <fudis-icon [class]="'fudis-mb-xxs'" [icon]="'info-circle-small'" [color]="'gray-dark'" />
      }
      @case ("CONFLICTS_WITH_STUDY_RIGHT") {
        | <fudis-icon [class]="'fudis-mb-xxs'" [icon]="'alert-small'" [color]="'red'" />
      }
    }
    {{ t("PLAN_STUDY_RIGHT_STATE." + state) }}
  </ng-template>
</ng-container>
